const EM_DASH = "\u2014";

/** Renders a value as a string, returning an em dash for null/undefined. */
function displayValue<T>(value: T | null | undefined): string {
  if (value === null || value === undefined) return EM_DASH;
  return String(value);
}

export { EM_DASH, displayValue };
